module.exports = __webpack_public_path__ + "static/media/Jelly-Places-Logo.8746f0c2.svg";